import { createStandardAction } from 'typesafe-actions';

const PAGES_HISTORY_HOME_PAGE_DETAILS_CONFIRM_DELETE = 'PAGES_HISTORY_HOME_PAGE_DETAILS_CONFIRM_DELETE';

export const confirmPagesHistoryDeletePage = createStandardAction(PAGES_HISTORY_HOME_PAGE_DETAILS_CONFIRM_DELETE)<
  string
>();



// WEBPACK FOOTER //
// ./src/containers/PagesHistory/PagesHistoryHome/PageDetails/actions.ts